// External
import { bool, node, func, any, shape, string, number, object } from 'prop-types';

// Internal
import { userTypes, userAccountTypes } from '../types/user';
import { selectedDepartmentTypes } from '../types/shop';
import { newAllotmentTypes } from '../types/allotments';

// constants
export const rootPropTypes = {
  userData: userTypes,
  account: userAccountTypes,
  accountsLoaded: bool.isRequired,
  children: node.isRequired,
  closeNavMenu: func.isRequired,
  currentAllotments: newAllotmentTypes,
  futureAllotments: newAllotmentTypes,
  getFeature: func.isRequired,
  getAccountDetails: func.isRequired,
  getAccountDepartments: func.isRequired,
  requestCurrentCartCrd: func.isRequired,
  getFundamentalData: func.isRequired,
  fetchGamedayAccount: func.isRequired,
  hasLoginStarted: bool.isRequired,
  history: any.isRequired,
  initializeUserAuth: func.isRequired,
  isAdminCart: bool.isRequired,
  isLoggedIn: bool.isRequired,
  lastLocation: shape({
    pathname: string
  }),
  selectedDepartment: selectedDepartmentTypes,
  selectShopDepartment: func.isRequired,
  // TEMPORARY REMOVAL, DO NOT DELETE
  // setAlwaysShowCart: func.isRequired,
  setDeepLinkInfoLoading: func.isRequired,
  setOrderDetails: func.isRequired,
  setUserAccount: func.isRequired,
  storeUserData: func.isRequired,
  isReturnStep: bool.isRequired,
  location: shape({
    pathname: string.isRequired
  }).isRequired,
  isStaticPage: bool.isRequired,
  modalIsVisible: bool.isRequired,
  currentCartCrd: string,
  setUseCurrentContract: func.isRequired,
  cartRecentlySubmitted: bool,
  hideDefaultTopNavigation: bool.isRequired,
  requestAllAddresses: func.isRequired,
  requestMinRules: func.isRequired,
  oktaAuth: object.isRequired
};

export const routerPropTypes = {
  component: func.isRequired,
  history: shape({
    action: string.isRequired,
    block: func.isRequired,
    createHref: func.isRequired,
    go: func.isRequired,
    goBack: func.isRequired,
    goForward: func.isRequired,
    length: number.isRequired,
    listen: func.isRequired,
    location: shape({
      hash: string.isRequired,
      key: string,
      pathname: string.isRequired,
      search: string.isRequired
    }).isRequired,
    push: func.isRequired,
    replace: func.isRequired
  }),
  oAuth: object
};

export const DEFAULT_ONPOPSTATE = () => {
  // Clear onpopstate, homie
};

export default {
  DEFAULT_ONPOPSTATE,
  rootPropTypes,
  routerPropTypes
};
